import { registerPlugin } from '@capacitor/core'
const NFC = registerPlugin('NFC')
export default NFC
